import CommonTable, {
  TableColumn,
} from '@/components/common/commonTable/CommonTable';
// import OrderStatusUpdate from '@/components/order/OrderStatus';
import { usePermissions } from '@/hooks/usePermissions';
import { ActionConfig } from '@/interfaces/common.interface';
// import { Order } from '@/interfaces/order.interface';
import {
  formatDateTime,
  getPaymentMethodMessage,
  toFixedThree,
} from '@/utility/helper';
import { RoutesLink } from '@/utility/RouteLinks';
import React, { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AssignDriver from './AssignDriver';
import { useSelectableTable } from '@/hooks/useSelectableTable';
import { RecentOrder } from '@/interfaces/dashboard.interface';
import OrderStatusUpdate from './OrderStatus';

interface RecentOrdersProp {
  orders: RecentOrder[];
  onSuccess: () => void;
}

const RecentOrders: React.FC<RecentOrdersProp> = ({ orders, onSuccess }) => {
  const navigate = useNavigate();
  const { canEdit, canView } = usePermissions();
  const [selectedOrderId, setSelectedOrderId] = useState<string | null>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const orderColumns: TableColumn<RecentOrder>[] = [
    {
      key: 'orderId',
      header: 'Order ID',
      render: (order) => (
        <span className={order.personalInfo.isEmployee ? 'text-blue-500' : ''}>
          {order.orderId}
        </span>
      ),
      className: 'p-3',
    },

    {
      key: 'dateTime',
      header: 'Date Time',
      render: (order) => (
        <span className={order.personalInfo.isEmployee ? 'text-blue-500' : ''}>
          {formatDateTime(order.deliveryTime, 'YYMMMDDHH')}
        </span>
      ),
    },
    {
      key: 'customer',
      header: 'Customer',
      render: (order) => (
        <span className={order.personalInfo.isEmployee ? 'text-blue-500' : ''}>
          {order.personalInfo.firstName} {order.personalInfo.lastName}
        </span>
      ),
    },
    {
      key: 'total',
      header: 'Total Amount BHD',
      render: (order) => (
        <span className={order.personalInfo.isEmployee ? 'text-blue-500' : ''}>
          {toFixedThree(order.grandTotal)}
        </span>
      ),
    },
    {
      key: 'orderStatus',
      header: 'Order Status',
      render: (order) => (
        <OrderStatusUpdate order={order} onSucess={() => onSuccess()} />
      ),
    },
    {
      key: 'paymentType',
      header: 'Payment Type',
      render: (order) => (
        <span className={order.personalInfo.isEmployee ? 'text-blue-500' : ''}>
          {getPaymentMethodMessage(order.paymentMethod?.type) ?? 'N/A'}
        </span>
      ),
    },
  ];

  const orderActionConfig: Record<string, ActionConfig<RecentOrder>> = {
    view: {
      text: 'View',
      onClick: (order) => navigate(`${RoutesLink.orderDetail}/${order.id}`),
      permission: () => canView('order'),
    },
  };

  const actions = useMemo(
    () =>
      Object.values(orderActionConfig)
        .filter((action) => action.permission())
        .map(({ permission, ...rest }) => rest),
    [canView, canEdit],
  );
  const { selectedItems, handleSelectAll, handleSelectItem } =
    useSelectableTable(orders);
  return (
    <div>
      <CommonTable
        columns={orderColumns}
        data={orders}
        showCheckbox={false}
        selectedItems={selectedItems}
        onSelectAll={handleSelectAll}
        onSelectItem={handleSelectItem}
        getItemId={(item) => item.id}
        emptyMessage="No Order found"
        actions={actions}
      />
      {isModalOpen && selectedOrderId && (
        <AssignDriver
          id={selectedOrderId}
          setIsOpen={setIsModalOpen}
          onSuccess={() => {
            (onSuccess(), setSelectedOrderId(null));
          }}
        />
      )}
    </div>
  );
};

export default RecentOrders;
